import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

import router from './router'
import store from '@/store/store'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
import Vue2Filters from 'vue2-filters'
import VueNumeric from 'vue-numeric'

Vue.use(VueMomentJS, moment)
Vue.use(Vue2Filters)
Vue.use(VueNumeric)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
